module.exports = __webpack_public_path__ + "img/a.392fb59a.jpg";